import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Icon Design Guidelines",
  "title": "Icon",
  "order": 2
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="icon" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Icons are visual symbols used to represent objects or actions. They
  communicate messages at a glance, clarify the nature of an interactive
  element, and draw attention to important information.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.13513513513513%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABH0lEQVQY0z2QW6+DIBCE+///W6liUEoDW25yEVlN7VsfTpTkfE+TbCazM7d930spOWdE3C5KKbVWRNz3HRFLKU0g4rqupZTl4jiOWwjh+XwSQoQQSikAoJQKIQCg1uqc45yHEABAKdX3PSGEMUYI+Xw+N2stpZQxZq0NIcQYpZRCCMbYOI7ThbXWez/P83/s4/E4zfM8c85fr1cIIaWktVYXxhgAkFK2U4wx57yuawjBe885P83e+2ma7vc7ABhjKKVKqff7LaXUWltrjTHHcWzbllL6/X4AMI5j13Vn52VZjDE555SStbbrOu89AHjvSylKqWEYGGMA4Jzr+15rbYxxzp3mtnZKqY0JAE0sy1JrjTG2wu3zpmOMiPj9fv8AmDN1vZScNQoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.15.0/static/cb322d69b248c7e698921066bd87bb26/e3189/icons-intro.png",
            "srcSet": ["/version/4.15.0/static/cb322d69b248c7e698921066bd87bb26/a2ead/icons-intro.png 259w", "/version/4.15.0/static/cb322d69b248c7e698921066bd87bb26/6b9fd/icons-intro.png 518w", "/version/4.15.0/static/cb322d69b248c7e698921066bd87bb26/e3189/icons-intro.png 1035w", "/version/4.15.0/static/cb322d69b248c7e698921066bd87bb26/aa440/icons-intro.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <h2>{`Icon Resources`}</h2>
      <p>{`React Magma primarily uses the beautiful icons from Material Design. Specifically we use the `}<a parentName="p" {...{
          "href": "https://material.io/resources/icons/?style=round"
        }}>{`rounded variant`}</a>{`. We also have a group of custom icons when Material doesn't have what we need, but we take great care to design those icons with the same `}<a parentName="p" {...{
          "href": "https://material.io/design/iconography/system-icons.html#design-principles"
        }}>{`principles`}</a>{` that Google does. Cengage designers can find these icons built into the Figma component libraries.`}</p>
      <hr></hr>
      <h2>{`Sizing`}</h2>
      <p>{`When choosing a size for your icon, you should choose a size that is evenly divisible by 8 in order for it to harmonize with the spacing system. If you are pairing the icon with a line of text, try to choose a size that matches the line-height of that text.`}</p>
      <p>{`The first example below shows a sample of acceptable icon sizes: 16px, 20px, 24px, 32px, 48px, 64px, 80px. The one exception to the sizing rule is the 20px icon. It is divisible by the smaller sub-unit of 4px, and is primarily for pairing with 14px text with a line-height of 20px.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "26.640926640926644%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAIAAADKYVtkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAsUlEQVQY012Qsa6EQAhF/f9/srC0MdFGC2NhLNQoM8AMoNXmSd7uZk9BLoELhCL/IyIeXahqSsnMVNVTLxHRcRzeU+SciYiZ8SE8IOI8z2Y2DMOyLKpa13Xf99d1tW1bluW+72b2Z+YHH0FEiEhE27aZ2TRN67qqatM04zje9911XVVVAKCqhYgAACLGL5gZAEQkhEBEIhJjdMHM53l+zvZVbxAxpRRCcA8i/phjjP6mF/g4GGCBzh8wAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.15.0/static/ddb9e6e439623c4135efe09e8d91dcbb/e3189/icon-sizes.png",
            "srcSet": ["/version/4.15.0/static/ddb9e6e439623c4135efe09e8d91dcbb/a2ead/icon-sizes.png 259w", "/version/4.15.0/static/ddb9e6e439623c4135efe09e8d91dcbb/6b9fd/icon-sizes.png 518w", "/version/4.15.0/static/ddb9e6e439623c4135efe09e8d91dcbb/e3189/icon-sizes.png 1035w", "/version/4.15.0/static/ddb9e6e439623c4135efe09e8d91dcbb/aa440/icon-sizes.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <p>{`This example illustrates how 12px, 14px, 16px, and 20px text strings are paired with icons sized to match their line-heights.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.18146718146718%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACBklEQVQoz21RXW/TMBTt/39DPADaByC0F/YA4mPsE9a1jGoby7J27Zq06Vjaxk4dO3butZ2MDeQCY9J2dXR1bOlcn+Nb0xqTLA8TFlE+JFlEeUT5gPDxjGeMgVTABPAcH6paacxxNHnrDdbao/de+OFkuNGN3/nRt/7FKAiBCRXEqjt6WAyIV9b8quzNLUpzU5nrypbWGmvRaLQatX5ArDWOmehNWZ/wgPDzKQuICAjvTdl4JlJCCp4jzyETCHDPtjWtMF5pdVcPzl879FaPgjd+tNLq7fd/eN+PJM8hpvI4AJo5F3dG1FzTf+s/nROjsTRGgzvMZfdsI6JQQCXQvEgVphLnHRwUslxxwUEW7sF7sWuVNbtnw2e7/otGe7nZed5sL+2dvjoIl+r+wl7700mw32ioTMCYSi8Ewu46dx+WCBkmWZSKMJmFyWxA2DAVA5KFCYtnnBJaCAm5KrgAVTgR3K4KsLLmpiqv3Z7K6zm5g/JnVbnkRpvSamOcyBqcJ6hZo08v6XpvstOfbvenO0GyEyR/yOdhunUer3cvD+NsMpl4npclqc4VUAa5dOKr0n7pDB9vHi7VTxbr/tPtw+Vm58nWwWLdf9nqL+x6j9a+fuxcnnW7G5sbNJ5oLqU/KGKKRtc0Ii90IpEopEpPuUxEQZUmEol0NySHmUIpJU1TLMDhn+3f9S7EyX+ojtQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/e3189/icon-text-balance.png",
            "srcSet": ["/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/a2ead/icon-text-balance.png 259w", "/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/6b9fd/icon-text-balance.png 518w", "/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/e3189/icon-text-balance.png 1035w", "/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/44d59/icon-text-balance.png 1553w", "/version/4.15.0/static/5a675c0f02fda567724c1063db0b2db7/8bb81/icon-text-balance.png 1602w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "65.63706563706563%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvUlEQVQoz83SMQqDMBTGcQ/sHbyLt8gqgpCIOLs4RHQxCL4078UQKCSQtraLdPE/Zfl9wyPZ44+ye2Ct9b7vABDf17AxxnvvnItvHUq733MfGAAYY13XEdG2bRSKxlpLRHHxjAHAe9/3fZ7nRVEopTjnQoiqqnioaZq6rpdlSXMvrLVGxHVdy7JkjCHiNE3DMIzjKKWc57ltWyGEUgoRzzh5FzLGIKINISIRWWuP43iXP64NoXShU/f8JFfxE1He3qSo0UE/AAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/c4caf9f75984b18dba62f2171a1102f9/f8915/icon-text-balance-correct.png",
                  "srcSet": ["/version/4.15.0/static/c4caf9f75984b18dba62f2171a1102f9/a2ead/icon-text-balance-correct.png 259w", "/version/4.15.0/static/c4caf9f75984b18dba62f2171a1102f9/6b9fd/icon-text-balance-correct.png 518w", "/version/4.15.0/static/c4caf9f75984b18dba62f2171a1102f9/f8915/icon-text-balance-correct.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            Maintain the balance of icons with text by using the line-height as
            a guide.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "65.63706563706563%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUElEQVQoz6WSwYrCMBBA/Urx0n9Q/IMFP0D/xJt32dJYkfYgqIelEqHooaRJOjOJ0i50Fre7VFjYdxoKbxpeMqj+weA5WWuVUgBgrdVa85e/ygDQNE2e52VZ1nVtrQWA7grb0iMDgFJqtVoNh8PpdLrdbolIKUVEzjkAQMT7/e69J6LnigGvZHk0Gi2Xy7eWpmniOH5vCcMwiqLdbrder6WUT/9LRsSiKIIgWCwW4/F4NpvVdZ3n+fF4zFqklEmSCCGu1ysifsuM1vpwOEwmk/l8LqWEFu+9a+HzO+cQsSdYVVWPx0NrDQDOOd5tjOHBduiXjTE8eO954F9xFCJCRL6CHpmzF0UhhDDGpGkaRZEQYrPZxHGcJEkYhpfL5UewX3JZlqfTqaqqLMv2+/1Hy/l8TtNUCHG73XqCdX0+NiLyxSIiEXHCl8G6T/VVpG6wTxRFyz9S6hgFAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/2dbd24cee754efed08ac49456c7cce19/f8915/icon-text-balance-incorrect.png",
                  "srcSet": ["/version/4.15.0/static/2dbd24cee754efed08ac49456c7cce19/a2ead/icon-text-balance-incorrect.png 259w", "/version/4.15.0/static/2dbd24cee754efed08ac49456c7cce19/6b9fd/icon-text-balance-incorrect.png 518w", "/version/4.15.0/static/2dbd24cee754efed08ac49456c7cce19/f8915/icon-text-balance-incorrect.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Don't let icons get too large or too small when paired with text.
            Use the line-height of the text as a guide.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <hr></hr>
      <h2>{`Color`}</h2>
      <p>{`Our icons are simple monochromatic symbols, and any color from the color palette may be applied to one. But responsible use of color is important.`}</p>
      <p>{`The color of an icon needs to hit a minimum color contrast ratio of 3:1 with the background it appears on. The color of the icon can help reflect the importance or nature of the action the icon is representing, but shouldn't rely on color alone. Text labels or tooltips are still important elements that can help make the action clearer to users.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "66.02316602316603%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJUlEQVQoz6WS0WrCMBSGfdDd7Al8hV3s2jfxCYZeG2pLp2jFoqIFJ22TpunJaXIkMqyMDRU7to9DLg78/P+fpKP/Qed2Za2t6/ovYkRcrVZZlmmt1RftYgBARKVUr9djjB0OB8/zoijyfT+OY2MMALQ4AwDnvCxLABBCSCmLBmhoj73ZbPI8N8YQ0aW/bUDER7GttUmSdLvdfr+fpuloNAqCIAzDIAgYY5xzRPzpf925LMvBcLhcLgFgt91+7PdZmq7X68VioZS6Mr8T2zlHRIhIzlnnTHPaZvOwMwASxc9P2eCtyjPuj8V0IvxxEc0rKdveGQCt3b2+CI9VoiimEzmfFe+hnM9AKd3i3FCfTmjtuQDReY5HJPrt99RVpS9XCvA998Sf1h/Z68loKBEAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/1013e8cfb38ea1126e259d3c59aec488/f8915/icon-color-correct.png",
                  "srcSet": ["/version/4.15.0/static/1013e8cfb38ea1126e259d3c59aec488/a2ead/icon-color-correct.png 259w", "/version/4.15.0/static/1013e8cfb38ea1126e259d3c59aec488/6b9fd/icon-color-correct.png 518w", "/version/4.15.0/static/1013e8cfb38ea1126e259d3c59aec488/f8915/icon-color-correct.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            It's nearly always a good idea to match the color of the icon with
            the text label, but sometimes you may want the icon to be a list
            more subtle than the text.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "66.02316602316603%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeklEQVQoz92SQQpDIQxEvf/VXJReQQUjBFH5nRhXXciXIqVdlC7aWQ0kLxlCzO0DmT+Dj2d6A68OAL13VRURAGMMEdn4HWbmUkpK6XLqespaS0SPI8y2lplzzrVWIooxeu+ncc6FEFprrzYDWJln7GVUdVa/c7AfeZI7cZ7l3Dx0QEAAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/80517a56dbbe65da50a2f4fac3ea405a/f8915/icon-color-too-light.png",
                  "srcSet": ["/version/4.15.0/static/80517a56dbbe65da50a2f4fac3ea405a/a2ead/icon-color-too-light.png 259w", "/version/4.15.0/static/80517a56dbbe65da50a2f4fac3ea405a/6b9fd/icon-color-too-light.png 518w", "/version/4.15.0/static/80517a56dbbe65da50a2f4fac3ea405a/f8915/icon-color-too-light.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            In this example, the icon only hits a contrast ratio of 1.7:1.
            Despit the fact there is a text label, the icons should still hit a
            minimum of 3:1.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "66.02316602316603%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAiUlEQVQoz92SvQrCQBCE8/7PkxdIY2kjATkSUPy5E0zCuTOb82zkgp0ELthIhi22+XaGYQv+oGJNsABUJQmkXUjkw3GMXh4kn6PGkGY6lQGr6vZY76/mdJdyd940t8q4S+eDKnKcG3sQiBca27duaN3Qe/k2n4kdYopAvsLC2J/CJgHE0sL+/knekfLn/rY5kwoAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/dfff44a5b92acde4ab787c0afce7c1c2/f8915/icon-mixed-colors.png",
                  "srcSet": ["/version/4.15.0/static/dfff44a5b92acde4ab787c0afce7c1c2/a2ead/icon-mixed-colors.png 259w", "/version/4.15.0/static/dfff44a5b92acde4ab787c0afce7c1c2/6b9fd/icon-mixed-colors.png 518w", "/version/4.15.0/static/dfff44a5b92acde4ab787c0afce7c1c2/f8915/icon-mixed-colors.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Do not mix colors when combining an icon with text, unless you are
            using different shades of the same color or using our default text
            color (#3F3F3F).
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
      <hr></hr>
      <h2>{`Alignment`}</h2>
      <p>{`When positioning an icon next to text you should always center-align them.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "64.09266409266408%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyklEQVQoz82S3wqCMBSHfd8uotfoInoA30KIqKi01KhbfYFAXExlbjvuKAiBI7E/JNGNH4cfuzgfYz9mwB8Yw5BFg3wAAN1Dj1xVVVmWiAgASimdRVEAgM7PspQSEW3bNk0ziiLOeZqmOhljQgje8CpnAjIBKZcM1HQ2H40nW+d4jW+L9cb2/L3ru+fL7uBay5XjnfRyO083h2FoWRZjLM9zQgilNEkSSmkcx0EQEEJ63lzXddGAiKpD28W3tjnn7z13+x/gJ/lVvgPvx94upNL8aAAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/06571a00618f12185e8dd2eee2892f3e/f8915/icon-text-centered.png",
                  "srcSet": ["/version/4.15.0/static/06571a00618f12185e8dd2eee2892f3e/a2ead/icon-text-centered.png 259w", "/version/4.15.0/static/06571a00618f12185e8dd2eee2892f3e/6b9fd/icon-text-centered.png 518w", "/version/4.15.0/static/06571a00618f12185e8dd2eee2892f3e/f8915/icon-text-centered.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`
            Always center-align icons with text when they're next to each other.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "748px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "64.09266409266408%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABVUlEQVQoz31Sy27CMBDkhxGfwA9wQ3wDZ3qoeoiANiQ0HAotoSk0BFxStSohysPrtQ2Hqli1CK+RZa0lj70zOyUognNOKQUAtV9HSVeMMUSMokhKqY6aT/e4SKaUcs6bzWa1WnVdFxGTJFGvAIAQgu9xkYyI9Xq9UqkMBoMwDA3DsHq9drvtOI5pmp1Ox3GcY3Kcg1oJ4Or7Z+i+Zkx8RfE0WM4WxCerRfj55gcPVt97n28yqu/H+YFmAEBEKSWllDHGTyCEuGgYAOR5nqapUpH/Q9ennpWKcxK73e7P6L3z6jdVnDdMdb/JaMr4ize9ub3bZDAnq6exO1uQ4XjizXzPD6bB0l9+HAouaEbEWq1WLpfvu904jk3TtGz7sd9/Ho1sy2q1WrZtH3VemLNhGI1GgxAipVSeqQkj4nq9Zoxd07zdbhVBJ1QXiHgtnjrPZ5N4Np6/QhXQlGNHxcQAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.15.0/static/4b91c04a758f2c7fe9c42a10910390b5/f8915/icon-text-wrong-alignment.png",
                  "srcSet": ["/version/4.15.0/static/4b91c04a758f2c7fe9c42a10910390b5/a2ead/icon-text-wrong-alignment.png 259w", "/version/4.15.0/static/4b91c04a758f2c7fe9c42a10910390b5/6b9fd/icon-text-wrong-alignment.png 518w", "/version/4.15.0/static/4b91c04a758f2c7fe9c42a10910390b5/f8915/icon-text-wrong-alignment.png 748w"],
                  "sizes": "(max-width: 748px) 100vw, 748px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Don't bottom-align or top-align icons with text when they're next to
            each other.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <span className="horizontal-spacer" />
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      